import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Initialize i18n
import './locales/i18n';

// Initialize MSW for development
import { initMSW } from './mock';

// 使用 import.meta.env.DEV 判断是否为开发模式，避免在浏览器端使用 process.env
async function enableMocking() {
  if (!import.meta.env.DEV) {
    return; // 非开发模式：不启动 MSW
  }
  await initMSW(); // 是否真正启动由 initMSW 内部的 VITE_ENABLE_MSW 控制
}

enableMocking().then(() => {
  // 修复：开发模式下 React.StrictMode 会导致 useEffect 执行两次，引发“进入页面第一页请求两次”的问题
  // 解决方案：移除 StrictMode 包裹，避免双执行（生产模式不受影响）
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <App />
  );
});
